




























import IndividualBizBankInfo from '@/components/popup/btt/IndividualBizBankInfo.vue'
import TransferBankAccountSelectionPopup from '@/components/popup/page/TransferBankAccountSelection.vue'
import PasswordPopup from '@/components/popup/page/Password.vue'
import {Component, Mixins, Prop, Watch} from 'vue-property-decorator'
import {namespace} from 'vuex-class'
import PopupHandlerMixin from '@/mixins/popupHandler'
import Translation from '@/mixins/Translation'
import {LogEventWidthGroupsPayload} from '@/store/modules/gtm/types'

const transfer = namespace('transfer')
const workflows = namespace('workflows')
const gtm = namespace('gtm')
const banks = namespace('banks')
const biz = namespace('biz')
const layout = namespace('layout')

@Component({
  components: {
    IndividualBizBankInfo,
    TransferBankAccountSelectionPopup,
    PasswordPopup,
  },
})

/**
 * 출금계좌 팝업 컴포넌트를 제어하는 wrapper
 */
export default class TransferPopups extends Mixins(PopupHandlerMixin, Translation) {
  @Prop({default: false, type: Boolean}) isOpen: boolean
  @Prop({default: 'terms', type: String}) translation: string

  @transfer.State('requestInfo') requestInfo
  @transfer.State('transfer') transfer
  @transfer.Mutation('clear') clearTransfer
  @transfer.Getter('gtmInfo') gtmInfo: object
  @transfer.Getter('totalTransferFee') totalTransferFee: number
  @transfer.Getter('totalAmount') totalAmount
  @transfer.Mutation('updateBankInfo') updateBankInfo
  @workflows.Action('cancelWorkflow') cancelWorkflow
  @gtm.Action('logEventWithGroups') logEventWithGroups:
    (payload: LogEventWidthGroupsPayload) => void
  @banks.State('banks') banks
  @banks.Action('getBanks') getBanks
  @banks.Mutation('clear') clearBanks
  @biz.State('isCorporate') isCorporate: boolean
  @layout.Mutation('updateError') updateError

  @Watch('isOpen')
  __isOpen(val) {
    if(val) {
      this.loadBanks()
    }
  }

  loadBanks() {
    const {getBanks, updateError, ts} = this
    getBanks()
      .then(() => {
        this.openPopup('transferBankAccountSelection')
      })
      .catch((error) => {
        updateError({
          id: 'get-banks',
          message: `${ts('bank-account')} 목록을 불러오는데 실패하였습니다.`,
        })
        throw error
      })
  }

  onSelectBank(bank) {
    this.updateBankInfo(bank)
  }

  openCertPopupAfterMove() {
    this.$router
      .push({
        name: 'cert-center',
        query: {
          callerPath: this.$route.fullPath,
          openPopupName: 'bankEnabling',
        }
      })
      .catch((err) => err)
  }

  onCloseAll() {
    this.clearBanks()
    this.clearTransfer()
    this.closePopup('transferBankAccountSelection')
    this.closePopup('password')
    this.$emit('on-after-close')
  }

  onClickCreateBankLink() {
    if(this.isCorporate) {
      this.openCertPopupAfterMove()
    } else {
      this.openPopup('individualBizBankInfo')
    }
  }

  cancelTransfer() {
    this.logEventWithGroups({
      eventType: 'complete',
      eventProperties: {
        ...this.gtmInfo,
        'charge': this.totalTransferFee,
        'complete_type': 'cancel',
      },
    })
    this.cancelWorkflow(this.requestInfo.workflow)
      .finally(() => {
        this.clearTransfer()
        this.onCloseAll()
      })
  }
}
